/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_StartedInputs */

const en_mobile_started = /** @type {(inputs: Mobile_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started`)
};

const es_mobile_started = /** @type {(inputs: Mobile_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciado`)
};

/**
* | output |
* | --- |
* | "Started" |
*
* @param {Mobile_StartedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_started = /** @type {((inputs?: Mobile_StartedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_StartedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_started(inputs)
	return en_mobile_started(inputs)
});